import { ISSRPageData } from '@interfaces'
import { ObjectService } from '@services'
import { ObjectTemplate } from '@templates'
import { createNavLink } from '@utils'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const ExhibitionAndEventObjectScreen = ({ pageData, global }: ISSRPageData) => {
  const { locale, query } = useRouter()
  const { t } = useTranslation()

  return (
    <ObjectTemplate
      global={global}
      pageData={pageData}
      headerLeftNavButtonLabel={t('nav:onlineExhibitions')}
      headerLeftNavButtonHref={`${createNavLink('online', locale)}/${
        query?.slug
      }`}
    />
  )
}

export default ExhibitionAndEventObjectScreen

/**
 * slug is collection sourceId
 * object is object of collection sourceId
 */
interface ISSRProps {
  query: {
    slug: string
    object: string
    periodId: string
    dId: string
  }
  locale: string
}

export async function getServerSideProps({ query, locale }: ISSRProps) {
  const { object, slug, periodId, dId } = query
  const pageData = {
    data: null,
    error: null,
  }

  try {
    const collection = await ObjectService.getObjectDetailPage(
      object,
      locale,
      'online',
      slug,
      periodId,
      dId
    )

    pageData.data = collection
  } catch (err) {
    if (err instanceof Error) {
      pageData.error = { message: err.message }
    }
  }

  if (!pageData.data && !pageData.error) {
    pageData.error = { message: 'Object not found' }
  }

  return {
    props: { pageData },
  }
}
